@if (definition) {
  @if (!loading) {
    @if (!virtual) {
      <ul class="soft-list">
        @for (item of items; track item) {
          <li
            (click)="toggleSelect(item); itemClick.emit(item)"
        [ngClass]="[
          'soft-list-item',
          'soft-list-item' + definition.type,
          (item | isSelected: selectedItem || selectedItems) ? 'selected' : '',
          itemClick.observed ? 'cursor-pointer' : ''
        ]"
            >
            <soft-dynamic-object
              [value]="item"
              [definition]="definition"
            ></soft-dynamic-object>
          </li>
        }
      </ul>
    } @else {
      @if (virtual) {
        <cdk-virtual-scroll-viewport
          [itemSize]="virtual.itemHeight"
          [ngClass]="virtual.class"
      [ngStyle]="{
        height:
          (virtual.display | virtualScrollItemDisplay: virtual.itemHeight) +
          'px'
      }"
          >
          <ul class="soft-list">
            <li
              *cdkVirtualFor="let item of items"
              (click)="toggleSelect(item)"
              [ngStyle]="{ height: virtual.itemHeight + 'px' }"
          [ngClass]="[
            'soft-list-item',
            'soft-list-item' + definition.type,
            (item | isSelected: selectedItem || selectedItems) ? 'selected' : ''
          ]"
              >
              <soft-dynamic-object
                [value]="item"
                [definition]="definition"
              ></soft-dynamic-object>
            </li>
          </ul>
        </cdk-virtual-scroll-viewport>
      }
    }
  } @else {
    <ul class="soft-list">
      <li
        *softRepeat="skeletonRows"
        [ngClass]="['soft-list-item', 'soft-list-item' + definition.type]"
        >
        <soft-dynamic-object
          [loading]="true"
          [definition]="definition"
        ></soft-dynamic-object>
      </li>
    </ul>
  }
}
